// extracted by mini-css-extract-plugin
module.exports = {"center":"Table_center__37Yiv"};